import styled from "@emotion/styled";
import { Autocomplete, autocompleteClasses, Popper, TextField } from "@mui/material";

export const StyledSuggestedSearch = styled(Autocomplete)({
	backgroundColor: "var(--white-50)",
	width: "341px",
	[`& .${autocompleteClasses.popupIndicator}`]: {
		transform: "none"
	}
}) as typeof Autocomplete;

export const SuggestedSearchTextField = styled(TextField)(({ theme }) => ({
	position: "relative",
	div: {
		div: {
			display: "flex",
			justifyContent: "flex-end"
		},
		input: {
			width: "100% !important"
		}
	},
	"& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder": {
		color: theme.project.colors.fontColors.secondary,
		opacity: 1
	},
	"& .MuiInputBase-root": {
		display: "flex",
		button: {
			marginRight: "8px",
			width: "32px",
			height: "32px"
		}
	},
	"& .MuiAutocomplete-endAdornment": {
		button: {
			position: "absolute",
			top: "50%",
			transform: "translateY(-50%)",
			right: "0px"
		}
	},
	"& .MuiInputAdornment-root": {
		button: {
			position: "absolute",
			top: "50%",
			transform: "translateY(-50%)"
		}
	}
}));

export const SuggestedSearchPopper = styled(Popper)(({ theme }) => ({
	div: {
		ul: {
			"& .MuiAutocomplete-option": {
				backgroundColor: theme.project.colors.backgroundColors.main + " !important"
			},
			"& .MuiAutocomplete-option.Mui-focused": {
				backgroundColor: theme.project.colors.allColors.hex.grayscale.gray100 + " !important"
			}
		}
	}
}));
